import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue';
import ModalBase from '@/components/ui/modals/modal-base.vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { MergeField } from '@/types/MergeField';
import GridBase from '../ui/grid/grid-base.vue';
import { DxColumn } from 'devextreme-vue/data-grid';
import { useMergeFieldsStore } from '@/stores/MergeFieldsStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'merge-fields-modal',
  props: {
    /** 
     * The boolean value used with `v-model` to control the visibility or state of a modal or component.
     * @type {boolean}
     * @required
     */
    modelValue: {
        type: Boolean,
        required: true,
    }
},
  emits: [
    /** 
     * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
     * @property {boolean} value - Indicates whether the modal has been opened or closed.
     */
    'update:modelValue',
    /** 
     * Emitted when a merge field is selected and added. 
     * @property {string} description - The description of the selected merge field.
     */
    'addMergeField'
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
    get: () => props.modelValue,
    set: (value: boolean) => emit('update:modelValue', value),
});

const onCancelClick = () => showModal.value = false;

const mergeFields = ref<MergeField[]>([]);
const selectedMergeField = ref<MergeField>({ description: '', fieldName: '' });
const mergeFieldsStore = useMergeFieldsStore();

const onSelectClick = () => {
    emit('addMergeField', selectedMergeField.value.description);
    showModal.value = false;
};

watch(() => showModal.value, async () => {
    if (!showModal.value) {
        return;
    }

    if (mergeFields.value.length == 0) {
        mergeFields.value = await mergeFieldsStore.returnMergeFields();
    }

    selectedMergeField.value = { description: '', fieldName: '' };
});

const fieldSelected = (e: MergeField) => {
    if (!e) {
        return;
    }
    selectedMergeField.value = e;
};

const fieldDoubleClicked = (e: MergeField) => {
    if (!e) {
        return;
    }
    selectedMergeField.value = e;
    emit('addMergeField', selectedMergeField.value.fieldName);
    showModal.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    title: "Merge Fields",
    height: "480px"
  }, {
    "non-scrollable-content": _withCtx(() => [
      _createVNode(GridBase, {
        dataSource: mergeFields.value,
        onRowSelected: fieldSelected,
        onRowClick: fieldDoubleClicked,
        idColumnName: "fieldName",
        "enable-key-press-detection": true
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "description",
            caption: "Description"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "fieldName",
            caption: "Field Name",
            visible: false
          })
        ]),
        _: 1
      }, 8, ["dataSource"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Select', visible: selectedMergeField.value.fieldName != '', onClick: () => { onSelectClick() } }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Cancel', onClick: () => { onCancelClick() } }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})